const _endpoint = '/api/MouseTracking/'; //Api endpoint

//Post mouse event history to api endpoint as a collection of pages.
const postHistory = (pages) => {
    return new Promise((resolve, reject) => {
        fetch(_endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(pages)
        }).then((response) => {
            if(response.ok) {
                resolve();
            } else {
                reject();
            }
        });
    });
};

const getHeatmapData = (url) => {
    return new Promise((resolve, reject) => {
        fetch(`${_endpoint}HeatMap?url=${url}`).then((response) => {
            response.json().then((data) => {
                resolve(data);
            },
            reject);
        },
        reject);
    });
};

export default {
    postHistory,
    getHeatmapData
};